export default __webpack_public_path__ + "static/media/like.80a5e959.png";